import React, { useState, useEffect } from 'react';
import { Button, TextField } from '@material-ui/core';
import CountDown from '../../components/CountDown';
import Loading from '../../components/Loading';
import Modal from '../../components/ModalOTP';
import axios from 'axios';
import { redirectToApp } from '../../utils/common';
import { observer } from 'mobx-react-lite';
import { useMst } from '../../models/Root';
import './index.css';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    title: {
        fontSize: '24px',
        textAlign: 'center',
        lineHeight: '32px',
        marginBottom: '24px',
    },
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
        '& .MuiButtonBase-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
        '& .MuiButton-root': {
            fontSize: '16px'
        }

    },
    btnLabel: {
        fontSize: '16px'
    },
    countDown: {
        display: 'flex',
        fontFamily: 'Roboto',
        flexDirection: 'column',
        fontSize: '16px',
        width: '100%',
        fontWeight: 500
    },
    resendOTP: {
        display: 'flex',
        justifyContent: "space-between"
    },
    titleCountDown: {
        display: 'flex',
        alignItems: 'center',
        lineHeight: 1.75,
        padding: '6px 8px'
    },
    countDownSpan: {
        display: 'flex',
        justifyContent: 'center',
        fontWeight: 500,
        letterSpacing: '0.02857em',
        width: '113px'
    },
    content: {
        fontFamily: 'Roboto',
        lineHeight: '16px',
        fontSize: '14px'
    }
}))
const url = {
    production: "https://otp-notify.moneylover.me/api",
    development: "https://test-otp-notify.moneylover.me/api",
    local: "http://localhost:8080/api"
}
const env = process.env.NODE_ENV;
const request = axios.create({
    baseURL: url[env]
})

export default observer(({ request_id, expiredAt }) => {
    const [otpCode, setOTP] = useState("")
    const [countDown, setCountDown] = useState(expiredAt);
    const [isOpen, setOpen] = useState(false);
    const [isError, setError] = useState(false);
    const [modalState] = useState({ title: "Phiên nhập OTP hết hạn", content: `Bạn vui lòng chọn "Đóng" và thử lại sau nhé!` })
    const classes = useStyles();
    const { otp, analytics } = useMst();

    const { loading, setLoading, isDisableResendOTP, changeDisableResendOTP, isOpenDialog, setLoadingState, setOpenDialog } = otp;
    const { title, content } = modalState;
    useEffect(() => {
        setCountDown(expiredAt * 1000)
    }, [expiredAt])

    const handleChangeOTP = (event) => {
        let otp = event.target.value;
        setOTP(otp)
    }

    const sendOTPClient = async () => {
        if (otpCode.length > 0) {
            setLoading(true)
            analytics.logEvent('otp_screen_send')
            await request.post("/finsify/otp", { otp: otpCode, retry: false, request_id: request_id })
        } else {
            setError(true)
        }
    }

    const timeUp = (isTimeUp = false) => {
        if (isTimeUp && !isOpenDialog) {
            setOpen(true)
            setOpenDialog()
            analytics.logEvent('otp_session_expired')
        }
    }

    const handleRetrySendOTP = async () => {
        changeDisableResendOTP(true)
        setLoadingState('pending')
        analytics.logEvent('otp_screen_resend')
        await request.post("/finsify/otp", { otp: "", retry: true, request_id: request_id })
    }

    const handleCloseDialog = () => {
        console.log("close EnterOTP.js")
        setOpen(false)
        analytics.logEvent('otp_dialog_close')
        redirectToApp()
    }


    return (
        <div className="enter-otp-main">
            <div className="enter-otp">
                <h3 className={classes.title}>Nhập mã OTP</h3>
                <span className={classes.content}>Nhập OTP để xác thực kết nối với ngân hàng.</span>
                <span className={classes.content} style={{ marginBottom: '32px' }}>LƯU Ý: Money Lover chỉ dùng OTP để lấy danh sách giao dịch</span>
                <TextField
                    type="text"
                    error={!otpCode && isError}
                    onChange={handleChangeOTP}
                    className="input-enter-otp"
                    placeholder="Enter OTP"
                    disabled={loading}
                    autoFocus
                    FormHelperTextProps={{style:{fontSize: "14px"}}}
                    helperText={!otpCode && isError ? "Bạn cần nhập OTP" : null}
                />

                {loading ? <Loading size={32} /> : null}
                {!loading ? <Button style={{ fontSize: '16px' }} variant="contained" color="primary" className={'btn-send-otp'} onClick={sendOTPClient}>Gửi</Button> : null // eslint-disable-line
                }
            </div>
            <div className="reset-otp">
                <div className={classes.countDown}>
                    <div className={classes.resendOTP}>
                        {!loading ? <Button disabled={isDisableResendOTP} className={classes.btnLabel} color="primary" onClick={handleRetrySendOTP}>Gửi lại OTP</Button> : <div></div>}
                        <span className={classes.titleCountDown}>Hết hạn trong</span>
                    </div>
                    {
                        isOpenDialog ? null :
                        <div style={{ display: 'flex', justifyContent: 'flex-end'}}>
                            <span className={classes.countDownSpan} >
                                <CountDown display={true} timeUp={timeUp} expiredAt={countDown} />
                            </span>
                        </div>
                    }
                </div>
                <Modal
                    isShowDialog={isOpen}
                    title={title}
                    content={content}
                    close={handleCloseDialog}
                />
            </div>
        </div>
    )
})